import React, { useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Editor } from '@tinymce/tinymce-react';

// Szövegszerkesztő popup (TinyMCE) az információs szövegekhez. Szándékosan egyszerű: nincs táblázat,
// kép, hivatkozás; csak igazítás, 3 betűméret, 3 betűtípus, dőlt, félkövér, betűszín, szimbólumos felsorolás és vízszintes vonal.
// A tinymce statikus fájljait a tools/copy-tinymce.js másolja a public/tinymce mappába.
const TINYMCE_SRC = '/tinymce/tinymce.min.js';

// A szerkesztő által megtartott elemek és stílusok. A régi tartalomban előforduló egyszerű elemek
// (felsorolás, div, center) megmaradnak, hogy a szerkesztés ne rombolja a meglévő szövegeket.
const ENGEDELYEZETT_ELEMEK = 'p[style],br,strong/b,em/i,span[style],div[style],center,hr,ul[style],ol[style],li[style]';
const ENGEDELYEZETT_STILUSOK = {
    '*': 'color,font-size,font-family,text-align,font-weight,font-style,margin-top,line-height,max-width',
};

const INIT = {
    menubar: false,
    statusbar: false,
    branding: false,
    promotion: false,
    height: 380,
    plugins: ['lists'],
    toolbar_mode: 'wrap',
    toolbar: 'undo redo | fontfamily fontsize | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist | hr | removeformat',
    font_size_formats: 'Kicsi=12px Normál=16px Nagy=24px',
    font_family_formats: 'Sans-serif=Arial,Helvetica,sans-serif; Serif=Georgia,"Times New Roman",serif; Monospace="Courier New",monospace',
    valid_elements: ENGEDELYEZETT_ELEMEK,
    valid_styles: ENGEDELYEZETT_STILUSOK,
    entity_encoding: 'raw',
    content_style: 'body { font-family: Arial, Helvetica, sans-serif; font-size: 16px; margin: 10px; }',
};

export default function HtmlSzerkeszto({ cim, ertek, onKesz, onMegse }) {
    const editorRef = useRef(null);

    function onClick_kesz() {
        onKesz(editorRef.current ? editorRef.current.getContent() : ertek);
    }

    return (
        // enforceFocus kikapcsolva: a TinyMCE saját felugró elemei (színválasztó, legördülők) a modalon kívül élnek
        <Modal show={true} onHide={onMegse} backdrop="static" enforceFocus={false}
            className="felsoModal" dialogClassName="szovegSzerkesztoDialog" backdropClassName="felsoModalHatter">
            <Modal.Header closeButton>
                <Modal.Title>{cim}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Editor
                    tinymceScriptSrc={TINYMCE_SRC}
                    initialValue={ertek}
                    init={INIT}
                    onInit={function (evt, editor) { editorRef.current = editor; }} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onMegse}>Mégse</Button>
                <Button variant="primary" onClick={onClick_kesz}>Kész</Button>
            </Modal.Footer>
        </Modal>
    );
}
